import styled from 'styled-components'

const FormContainer = styled('form')`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export default FormContainer
